import React from 'react';

import { graphql } from 'gatsby';

// eslint-disable-next-line react/display-name
export default () => {
  return <></>;
};

export const query = graphql`
  fragment SeoFragment on STRAPI__COMPONENT_SHARED_SEO {
    __typename
    id
    metaTitle
    metaDescription
    metaImage {
      localFile {
        publicURL
        childImageSharp {
          gatsbyImageData(aspectRatio: 1.77, quality: 100)
        }
      }
    }
    keywords
    canonicalURL
    metaRobots
    metaSocial {
      title
      socialNetwork
      description
      image {
        localFile {
          publicURL
          childImageSharp {
            gatsbyImageData(aspectRatio: 1.77, quality: 100)
          }
        }
      }
    }
  }
  fragment PageSectionsFragment on STRAPI_SECTION {
    __typename
    title
    id
    subTitle
    block {
      __typename
      ... on ComponentPageBlocksWelcomSection {
        id
        mainImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(
                width: 1400
                placeholder: BLURRED
                blurredOptions: { width: 350 }
                formats: [AUTO, WEBP, AVIF]
                quality: 90
              )
            }
          }
          altText
        }
        mainMobileImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(
                width: 300
                placeholder: BLURRED
                blurredOptions: { width: 20 }
                formats: [AUTO, WEBP, AVIF]
                quality: 85
              )
            }
          }
          altText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksHeroSection {
        id
        mainImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(
                width: 1400
                placeholder: BLURRED
                blurredOptions: { width: 350 }
                formats: [AUTO, WEBP, AVIF]
                quality: 90
              )
            }
          }
          altText
        }
        mainMobileImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(
                width: 300
                placeholder: BLURRED
                blurredOptions: { width: 20 }
                formats: [AUTO, WEBP, AVIF]
                quality: 85
              )
            }
          }
          altText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksMaintenanceSection {
        id
        top_paragraph
        middle_paragraph
        bottom_paragraph
        mainImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(
                width: 1400
                placeholder: BLURRED
                blurredOptions: { width: 350 }
                formats: [AUTO, WEBP, AVIF]
                quality: 90
              )
            }
          }
          altText
        }
        mainMobileImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(
                width: 300
                placeholder: BLURRED
                blurredOptions: { width: 20 }
                formats: [AUTO, WEBP, AVIF]
                quality: 85
              )
            }
          }
          altText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksSupportSection {
        id
        supportBlock {
          description
          title
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksLPStepsSection {
        id
        steps {
          description
          title
          substring
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        display
      }
      ... on ComponentPageBlocksLPFunctionsSliderSection {
        id
        slides {
          id
          title
          description
          btn {
            buttonLink
            buttonText
            buttonVariant
            page {
              slug
            }
          }
          image {
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  width: 1920
                  placeholder: BLURRED
                  blurredOptions: { width: 20 }
                  formats: [AUTO, WEBP, AVIF]
                  quality: 85
                )
              }
            }
            altText
          }
          imageMobile {
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  width: 769
                  placeholder: BLURRED
                  blurredOptions: { width: 20 }
                  formats: [AUTO, WEBP, AVIF]
                  quality: 85
                )
              }
            }
            altText
          }
        }
      }
      ... on ComponentPageBlocksLPStatsSection {
        id
        items {
          id
          title
          description
        }
      }
      ... on ComponentPageBlocksLPBenefitsOnlineSection {
        id
        image {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 940, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 90)
            }
          }
          altText
        }
        items {
          id
          iconType
          title
          description
        }
      }
      ... on ComponentPageBlocksLPAdvantagesSection {
        id
        image {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 940, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 90)
            }
          }
          altText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        items {
          description
          title
          id
          iconType
        }
      }
      ... on ComponentPageBlocksLPAdvantagesMobileSection {
        id
        imageTop {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 660, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 85)
            }
          }
          altText
        }
        imageBottom {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 660, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 85)
            }
          }
          altText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        items {
          description
          title
          id
          iconType
        }
      }
      ... on ComponentPageBlocksAdvantagesSection {
        id
        image {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 940, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 90)
            }
          }
          altText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        items {
          description
          title
          id
          iconType
        }
      }
      ... on ComponentPageBlocksMarkdownSection {
        content
        contentImages {
          id
          url
          childImageSharp {
            gatsbyImageData(aspectRatio: 1, formats: [AUTO, WEBP, AVIF], quality: 90, placeholder: BLURRED)
          }
        }
      }
      ... on ComponentPageBlocksFaqSection {
        items {
          question
          answer
        }
      }
      ... on ComponentPageBlocksLPFaqSection {
        items {
          question
          answer
        }
      }
      ... on ComponentPageBlocksTeamSection {
        teammates {
          image {
            imageFile {
              childImageSharp {
                gatsbyImageData(quality: 90, formats: [AUTO, WEBP, AVIF], placeholder: BLURRED)
              }
            }
            altText
          }
          name
          specialization
        }
        scientific {
          image {
            imageFile {
              childImageSharp {
                gatsbyImageData(aspectRatio: 1, quality: 90)
              }
            }
            altText
          }
          name
          description
        }
      }
      ... on ComponentPageBlocksListOfPointsSection {
        points {
          text
        }
      }
      ... on ComponentPageBlocksPartnersSection {
        logo {
          imageFile {
            childImageSharp {
              gatsbyImageData(formats: [AUTO, WEBP, AVIF], width: 915, quality: 90, placeholder: BLURRED)
            }
          }
          altText
        }
      }
      ... on ComponentPageBlocksOurMissionSection {
        description
      }
      ... on ComponentPageBlocksWorkInfoSection {
        image {
          imageFile {
            childImageSharp {
              gatsbyImageData(aspectRatio: 1, quality: 90, placeholder: BLURRED)
            }
          }
          altText
        }
        works {
          text
        }
      }
      ... on ComponentPageBlocksReviewSection {
        items {
          author
          review
        }
      }
      ... on ComponentPageBlocksLPReviewSection {
        items {
          author
          review
          years
        }
      }
      ... on ComponentPageBlocksAboutSection {
        title
        description
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksPsychologistSection {
        benefits {
          benefit
        }
        psychologist {
          psychologistName
          grade
          psychologistImageFile {
            childImageSharp {
              gatsbyImageData(width: 336, height: 336, quality: 90, placeholder: BLURRED)
            }
          }
          licenseImageFile {
            childImageSharp {
              gatsbyImageData(width: 94, height: 94, quality: 90, placeholder: BLURRED)
            }
          }
          line {
            lineName
            description
          }
        }
      }
      ... on ComponentPageBlocksLPStaffAdvantagesSection {
        id
        avatars {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 336, height: 336, quality: 90, placeholder: BLURRED)
            }
          }
          altText
        }
        benefits {
          benefit
        }
      }
      ... on ComponentPageBlocksSponsorsSection {
        title
        image {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 735, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 90)
            }
          }
          altText
        }
      }
      ... on ComponentPageBlocksLPSponsorsSection {
        title
        image {
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 477, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 85)
            }
          }
          altText
        }
      }
      ... on ComponentPageBlocksLPCompareSection {
        comparePoints {
          title
          val1
          val2
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksThemesSection {
        themen {
          theme
          explanation
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksLPThemesSection {
        themen {
          theme
          explanation
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksThemesSectionAccordion {
        themen {
          theme
          explanation
        }
      }
      ... on ComponentPageBlocksBlogSection {
        numberOfPosts
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksLPBlogSection {
        numberOfPosts
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksPromoSection {
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        promoCards {
          image {
            imageFile {
              childImageSharp {
                gatsbyImageData(aspectRatio: 1.77, quality: 90, placeholder: BLURRED)
              }
            }
            altText
          }
          title
          description
        }
      }
      ... on ComponentPageBlocksNewsletterSection {
        richText {
          content
          contentImages {
            id
            url
            childImageSharp {
              gatsbyImageData(width: 470, formats: [AUTO, WEBP, AVIF], quality: 90, placeholder: BLURRED)
            }
          }
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksProductsSection {
        products {
          productName
          productMetaTag
          productPrice
          productDuration
          productDescription {
            advantage
          }
          productPromoText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksFullWidthBannerSection {
        bannerTitle
        bannerSubTitle
        variant
        bannerImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], layout: FULL_WIDTH, quality: 90)
            }
          }
          altText
        }
        bannerImageMobile {
          imageFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], layout: FULL_WIDTH, quality: 90)
            }
          }
          altText
        }
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksContactUsSection {
        contactText
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksContactUsFormSection {
        formName
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        successTitle
        successDescription
        successButton {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksDemoFormBusinessSection {
        formName
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        successTitle
        successDescription
        successButton {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksSuicideBannerSection {
        bannerText {
          content
          contentImages {
            id
            url
            childImageSharp {
              gatsbyImageData(width: 470, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 90)
            }
          }
        }
        bannerTitle
      }
      ... on ComponentPageBlocksStatisticsSection {
        items {
          measure
          explanation
        }
      }
      ... on ComponentPageBlocksPromoAdvantages {
        items {
          advantage
          icon
        }
      }
      ... on ComponentPageBlocksTestStartedButtonSection {
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
      }
      ... on ComponentPageBlocksShareSection {
        shareText
      }
      ... on ComponentPageBlocksAboutUsHeaderSection {
        backgroundImage {
          imageFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], layout: FULL_WIDTH, quality: 90)
            }
          }
          altText
        }
        backgroundImageMobile {
          imageFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], width: 769, quality: 90)
            }
          }
          altText
        }
        description
      }
      ... on ComponentPageBlocksAdvantagesBusinessSection {
        id
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        items {
          description
          title
          id
          iconType
        }
      }
      ... on ComponentPageBlocksPromoBusinessSection {
        id
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        promotions {
          image {
            imageFile {
              childImageSharp {
                gatsbyImageData(quality: 88, formats: [AUTO, WEBP, AVIF], placeholder: BLURRED, width: 600)
              }
            }
            altText
          }
          title
          description
        }
      }
      ... on ComponentPageBlocksBusinessPsychologistSection {
        items {
          text
        }
      }
      ... on ComponentPageBlocksBusinessBenefitsSection {
        image {
          imageFile {
            childImageSharp {
              gatsbyImageData(quality: 90, formats: [AUTO, WEBP, AVIF], placeholder: BLURRED)
            }
          }
          altText
        }
        firstTextBlock {
          title
          description
        }
        secondTextBlock {
          title
          description
        }
        thirdTextBlock {
          title
          description
        }
      }
      ... on ComponentPageBlocksPartnersBusinessSection {
        button {
          buttonLink
          buttonText
          buttonVariant
          page {
            slug
          }
        }
        businesspartners {
          description
          image {
            imageFile {
              childImageSharp {
                gatsbyImageData(quality: 88, formats: [AUTO, WEBP, AVIF], placeholder: BLURRED, layout: CONSTRAINED)
              }
            }
            altText
          }
        }
      }
    }
  }
  fragment NavigationEdges on StrapiNavigationConnection {
    edges {
      node {
        name
        slug
        localeCode
        pages {
          slug
        }
        items {
          title
          type
          path
          externalPath
          uiRouterKey
          related {
            __typename
            title
            slug
            _xcontentType
            navigationItemId
          }
          items {
            path
            type
            externalPath
            uiRouterKey
            type
          }
        }
      }
    }
  }
  fragment PostsEdges on STRAPI_BLOG_POSTConnection {
    edges {
      node {
        title
        slug
        publishedAt
        postPreviewText
        postCategory {
          title
          slug
        }
        blogPreview {
          picture {
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(quality: 90, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
              }
            }
          }
          altText
        }
      }
    }
  }
  fragment SiteSettingsEdges on STRAPI_GLOBALConnection {
    edges {
      node {
        legalInformation
        copyright
        socialLinks {
          social
          socialLink
        }
        contacts {
          contactType
          contactLabel
          contactInfo
        }
        locale
        footerLogo {
          altText
          picture {
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(width: 85, layout: FIXED, quality: 90)
              }
            }
          }
        }
        siteLogo {
          altText
          picture {
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(width: 85, layout: FIXED, quality: 90)
              }
            }
          }
        }
      }
    }
  }
`;